import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/CustomNavbar";
import Footer from "./components/Footer/Footer";
import Hero from "./components/Hero/Hero";
import References from "./components/References/References";
import Services from "./Services/Services";
import ContactForm from "./ContactForm/ContactForm";
import Gallery from "./components/Gallery/Gallery";
import Impressum from "./pages/Impressum/Impressum";
import Datenschutz from "./pages/Datenschutz/datenschutz";
import './App.css';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <References />
            <Gallery />
            <Services />
            <ContactForm />
          </>
        } />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
